import angular, { IScope } from 'angular';
import uiRouter, { StateService } from '@uirouter/angularjs';
import { TODO } from '@b2b/types/core';

DashboardController.$inject = ['$scope', '$state', 'AuthService'];

function DashboardController($scope: IScope & { dashboard: TODO }, $state: StateService, AuthService: TODO) {
  const ctrl = {
    init: function () {
      $scope.$emit('Application::contentTitleChange', {});

      $state.go('application.dashboardUser', {}, { notify: true });
    },
  };

  $scope.dashboard = ctrl;
  ctrl.init();
}

export const DashboardControllerModule = angular
  .module('acme.view.application.dashboard.controllers', [uiRouter, 'acme.common.service.auth'])
  .controller('DashboardController', DashboardController).name;
